import React from "react";
import { Link } from "react-router-dom";

export function Notfound() {
  return (
    <div className="page-bg error-404-bg">
      <div className="page-overlay">
        <div className="error-404-section">
          <div className="container">
            <div className="row justify-content-center align-items-center min-vh-100 py-5">
              <div className="col-lg-8 text-center">
                {/* Error Code */}
                <div className="error-code-wrapper mb-4">
                  <h1 className="error-code display-1 fw-bold text-warning mb-0">
                    404
                  </h1>
                  <div className="error-icon-wrapper">
                    <i className="bi bi-exclamation-triangle-fill text-warning"></i>
                  </div>
                </div>

                {/* Error Message */}
                <h2 className="fw-bold mb-3">Page Not Found</h2>
                <p className="lead text-muted mb-4">
                  Oops! The page you're looking for seems to have wandered off
                  into the digital void. It might have been moved, deleted, or
                  perhaps it never existed.
                </p>

                {/* Helpful Suggestions */}
                <div className="error-suggestions bg-light rounded-3 p-4 mb-4">
                  <h5 className="fw-bold mb-3">Here's what you can do:</h5>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <i className="bi bi-check-circle text-success me-2"></i>
                      Check the URL for typos or errors
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-check-circle text-success me-2"></i>
                      Use the navigation menu to find what you need
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-check-circle text-success me-2"></i>
                      Go back to the homepage and start fresh
                    </li>
                    <li className="mb-0">
                      <i className="bi bi-check-circle text-success me-2"></i>
                      Contact us if you think this is an error
                    </li>
                  </ul>
                </div>

                {/* Action Buttons */}
                <div className="error-actions d-flex flex-wrap gap-3 justify-content-center mb-5">
                  <Link to="/" className="btn btn-warning btn-lg px-4">
                    <i className="bi bi-house-fill me-2"></i>
                    Back to Home
                  </Link>
                  <Link
                    to="/services"
                    className="btn btn-outline-dark btn-lg px-4"
                  >
                    <i className="bi bi-grid-fill me-2"></i>
                    View Services
                  </Link>
                  <Link
                    to="/contact"
                    className="btn btn-outline-dark btn-lg px-4"
                  >
                    <i className="bi bi-envelope-fill me-2"></i>
                    Contact Us
                  </Link>
                </div>

                {/* Quick Links */}
                <div className="quick-links">
                  <h6 className="fw-bold mb-3">Quick Links</h6>
                  <div className="d-flex flex-wrap gap-3 justify-content-center">
                    <Link
                      to="/"
                      className="text-decoration-none text-muted hover-warning"
                    >
                      Home
                    </Link>
                    <span className="text-muted">•</span>
                    <Link
                      to="/services"
                      className="text-decoration-none text-muted hover-warning"
                    >
                      Services
                    </Link>
                    <span className="text-muted">•</span>
                    <Link
                      to="/clients"
                      className="text-decoration-none text-muted hover-warning"
                    >
                      Clients
                    </Link>
                    <span className="text-muted">•</span>
                    <Link
                      to="/contact"
                      className="text-decoration-none text-muted hover-warning"
                    >
                      Contact
                    </Link>
                  </div>
                </div>

                {/* Fun Animation */}
                {/* <div className="error-animation mt-5">
                  <div className="floating-elements">
                    <i className="bi bi-code-slash text-warning floating-icon"></i>
                    <i className="bi bi-braces text-warning floating-icon"></i>
                    <i className="bi bi-terminal text-warning floating-icon"></i>
                    <i className="bi bi-cpu text-warning floating-icon"></i>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
